// src/utils/cx.ts
function cx(...parts) {
  return parts.filter(Boolean).join(" ");
}

export { cx };
//# sourceMappingURL=chunk-BIIWHS2O.js.map
//# sourceMappingURL=chunk-BIIWHS2O.js.map